import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const RegulationsPage = lazy(() => import('../pages/regulations/page'));
const NetworkingPage = lazy(() => import('../pages/networking/page'));
const DemographicsPage = lazy(() => import('../pages/demographics/page'));
const GuidesPage = lazy(() => import('../pages/guides/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Business Planning Resources
const BusinessPlanTemplatePage = lazy(() => import('../pages/resources/business-plan-template/page'));
const FinancialProjectionsGuidePage = lazy(() => import('../pages/resources/financial-projections-guide/page'));
const MarketResearchToolsPage = lazy(() => import('../pages/resources/market-research-tools/page'));

// Legal & Compliance Resources
const BusinessStructureGuidePage = lazy(() => import('../pages/resources/business-structure-guide/page'));
const PermitLicenseChecklistPage = lazy(() => import('../pages/resources/permit-license-checklist/page'));
const TaxRegistrationGuidePage = lazy(() => import('../pages/resources/tax-registration-guide/page'));

// Funding Options Resources
const SmallBusinessLoansPage = lazy(() => import('../pages/resources/small-business-loans/page'));
const GrantOpportunitiesPage = lazy(() => import('../pages/resources/grant-opportunities/page'));
const InvestorNetworkPage = lazy(() => import('../pages/resources/investor-network/page'));

// Marketing & Growth Resources
const DigitalMarketingGuidePage = lazy(() => import('../pages/resources/digital-marketing-guide/page'));
const BrandingResourcesPage = lazy(() => import('../pages/resources/branding-resources/page'));
const SocialMediaStrategyPage = lazy(() => import('../pages/resources/social-media-strategy/page'));

// Regulations Pages
const BusinessRegistrationPage = lazy(() => import('../pages/regulations/business-registration/page'));
const LocalPermitsLicensesPage = lazy(() => import('../pages/regulations/local-permits-licenses/page'));
const TaxRequirementsPage = lazy(() => import('../pages/regulations/tax-requirements/page'));
const ZoningCompliancePage = lazy(() => import('../pages/regulations/zoning-compliance/page'));
const TexasSecretaryOfStatePage = lazy(() => import('../pages/regulations/texas-secretary-of-state/page'));
const CityOfElPasoBusinessLicensePage = lazy(() => import('../pages/regulations/city-of-el-paso-business-license/page'));
const TexasComptrollerPage = lazy(() => import('../pages/regulations/texas-comptroller/page'));
const IRSSmallBusinessResourcesPage = lazy(() => import('../pages/regulations/irs-small-business-resources/page'));

// Demographics Detail Pages
const BilingualMarketPage = lazy(() => import('../pages/demographics/bilingual-market/page'));
const BorderEconomyPage = lazy(() => import('../pages/demographics/border-economy/page'));
const GrowingTechSectorPage = lazy(() => import('../pages/demographics/growing-tech-sector/page'));
const MilitaryPresencePage = lazy(() => import('../pages/demographics/military-presence/page'));

const UTEPPage = lazy(() => import('../pages/guides/utep/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/resources/business-plan-template',
    element: <BusinessPlanTemplatePage />,
  },
  {
    path: '/resources/financial-projections-guide',
    element: <FinancialProjectionsGuidePage />,
  },
  {
    path: '/resources/market-research-tools',
    element: <MarketResearchToolsPage />,
  },
  {
    path: '/resources/business-structure-guide',
    element: <BusinessStructureGuidePage />,
  },
  {
    path: '/resources/permit-license-checklist',
    element: <PermitLicenseChecklistPage />,
  },
  {
    path: '/resources/tax-registration-guide',
    element: <TaxRegistrationGuidePage />,
  },
  {
    path: '/resources/small-business-loans',
    element: <SmallBusinessLoansPage />,
  },
  {
    path: '/resources/grant-opportunities',
    element: <GrantOpportunitiesPage />,
  },
  {
    path: '/resources/investor-network',
    element: <InvestorNetworkPage />,
  },
  {
    path: '/resources/digital-marketing-guide',
    element: <DigitalMarketingGuidePage />,
  },
  {
    path: '/resources/branding-resources',
    element: <BrandingResourcesPage />,
  },
  {
    path: '/resources/social-media-strategy',
    element: <SocialMediaStrategyPage />,
  },
  {
    path: '/regulations',
    element: <RegulationsPage />,
  },
  {
    path: '/regulations/business-registration',
    element: <BusinessRegistrationPage />,
  },
  {
    path: '/regulations/local-permits-licenses',
    element: <LocalPermitsLicensesPage />,
  },
  {
    path: '/regulations/tax-requirements',
    element: <TaxRequirementsPage />,
  },
  {
    path: '/regulations/zoning-compliance',
    element: <ZoningCompliancePage />,
  },
  {
    path: '/regulations/texas-secretary-of-state',
    element: <TexasSecretaryOfStatePage />,
  },
  {
    path: '/regulations/city-of-el-paso-business-license',
    element: <CityOfElPasoBusinessLicensePage />,
  },
  {
    path: '/regulations/texas-comptroller',
    element: <TexasComptrollerPage />,
  },
  {
    path: '/regulations/irs-small-business-resources',
    element: <IRSSmallBusinessResourcesPage />,
  },
  {
    path: '/networking',
    element: <NetworkingPage />,
  },
  {
    path: '/demographics',
    element: <DemographicsPage />,
  },
  {
    path: '/demographics/bilingual-market',
    element: <BilingualMarketPage />,
  },
  {
    path: '/demographics/border-economy',
    element: <BorderEconomyPage />,
  },
  {
    path: '/demographics/growing-tech-sector',
    element: <GrowingTechSectorPage />,
  },
  {
    path: '/demographics/military-presence',
    element: <MilitaryPresencePage />,
  },
  {
    path: '/guides',
    element: <GuidesPage />,
  },
  {
    path: '/guides/utep',
    element: <UTEPPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;